<crm-object-association-panel
  [id]="id()"
  [name]="name()"
  [objectType]="objectType()"
  [associatedObject]="'Opportunity'"
  [createCardData]="cardFunction"
  [customHeaderContent]="headerContent"
  [customCardContent]="cardContent"
></crm-object-association-panel>

<ng-template #cardContent let-card="card">
  @switch (card.status) {
    @case (ClosedWon) {
      <glxy-badge color="green" class="opportunity-status">
        {{ 'OPPORTUNITY.ASSOCIATION_PANEL.STATUS.CLOSED_WON' | translate }}
      </glxy-badge>
    }
    @case (ClosedLost) {
      <glxy-badge color="red" class="opportunity-status">
        {{ 'OPPORTUNITY.ASSOCIATION_PANEL.STATUS.CLOSED_LOST' | translate }}
      </glxy-badge>
    }
    @case (Open) {
      <glxy-badge color="blue" class="opportunity-status">
        {{ 'OPPORTUNITY.ASSOCIATION_PANEL.STATUS.OPEN' | translate }}
      </glxy-badge>
    }
  }
</ng-template>

<ng-template #headerContent let-card="card">
  <div class="opportunity-details">
    <span>
      {{ 'OPPORTUNITY.ASSOCIATION_PANEL.VALUE' | translate }}:
      {{ card.value || 0 | glxyCurrency: card.currency }}
    </span>
    @if (card.lastActivity) {
      <span>
        {{ 'OPPORTUNITY.ASSOCIATION_PANEL.ACTIVITY' | translate }}:
        {{ card.lastActivity | date: 'mediumDate' }}
      </span>
    }
    @if (card.expectedClose) {
      <span>
        {{ 'OPPORTUNITY.ASSOCIATION_PANEL.CLOSE_DATE' | translate }}:
        {{ card.expectedClose | date: 'mediumDate' }}
      </span>
    }
    @if (card.stageName$ | async; as stageName) {
      <span>{{ 'OPPORTUNITY.ASSOCIATION_PANEL.STAGE' | translate }}: {{ stageName }}</span>
    }
  </div>
</ng-template>
